import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot, UrlTree } from '@angular/router';
import { ChecksService } from './checks.service';

@Injectable({
  providedIn: 'root'
})
export class PermissionGuard implements CanActivate {
  constructor(
    private checkService: ChecksService,
    private router: Router,
  ) {}

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean|UrlTree {
    this.checkService.checkSession();

    if (this.checkService.canAccessUrl(state.url)) {
      return true;
    }

    return this.router.parseUrl(this.checkService.firstAllowedRoute());
  }
}
